import styled, { keyframes } from 'vue3-styled-components';

/* 모달 컨테이너 */
export const ModalContainer = styled.div`
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modalIn 0.3s ease-out;
`;

/* 모달 헤더 */
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
`;

export const ModalTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
`;

export const CalculatorIcon = styled.span`
  font-size: 20px;
`;

/* 탭 네비게이션 */
export const TabContainer = styled.div`
  display: flex;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
`;

export const TabButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  
  &:hover {
    background: rgba(99, 102, 241, 0.1);
    color: #6366f1;
  }
  
  &.active {
    background: white;
    color: #6366f1;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 2px;
      background: linear-gradient(90deg, #6366f1, #8b5cf6);
    }
  }
`;

/* 모달 바디 */
export const ModalBody = styled.div`
  flex: 1;
  padding: 10px;
`;

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/* 정보 섹션 */
export const InfoSection = styled.div`
  background: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  max-height: 250px;
`;

export const SectionTitleCompact = styled.h3`
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
`;

/* 폼 스타일 */
export const FormGridCompact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FormGroupInline = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FormLabelCompact = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  min-width: 120px;
  flex-shrink: 0;
`;

export const FormInputCompact = styled.input`
  flex: 1;
  max-width: 50px;
  padding: 8px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  
  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
  }
`;

export const UnitLabel = styled.span`
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  min-width: 40px;
`;

/* 2열 그리드 레이아웃 */
export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
`;

/* 품목 정보 섹션 */
export const CompactProductInfoSection = styled.div`
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
    
    &:hover {
      background: #94a3b8;
    }
  }
`;

export const CompactProductList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CompactProductItem = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  
  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
    transform: translateY(-1px);
  }
`;

export const CompactProductHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  gap: 8px;
`;

export const CompactProductName = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.3;
  word-break: break-word;
  flex: 1;
`;

export const CompactProductType = styled.div`
  flex-shrink: 0;
`;

export const TypeBadge = styled.span`
  display: inline-block;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 12px;
  white-space: nowrap;
`;

export const CompactProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CompactProductDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
`;

export const CompactDetailLabel = styled.span`
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
`;

export const CompactDetailValue = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  
  &.total-count {
    color: #059669;
    font-size: 13px;
  }
`;

// 인라인 수량 조절 컨트롤 추가
export const QuantityControlInline = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 1px;
`;

export const QuantityButtonInline = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: white;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: #3b82f6;
    color: white;
  }
  
  &:disabled {
    background: #f1f5f9;
    color: #cbd5e1;
    cursor: not-allowed;
  }
`;

export const QuantityInputInline = styled.input`
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #1e293b;
  
  &:focus {
    outline: none;
  }
`;

export const EmptyProduct = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  text-align: center;
  background: white;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #3b82f6;
    background: #f8fafc;
  }
`;

export const EmptyIcon = styled.div`
  font-size: 24px;
  margin-bottom: 8px;
  opacity: 0.6;
`;

export const EmptyText = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 4px;
`;

export const EmptySubText = styled.div`
  font-size: 11px;
  color: #94a3b8;
`;

/* 청구 계산 결과 테이블 */
export const ClaimResultTable = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
`;

export const TableHeader = styled.thead`
  background: #f8fafc;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e2e8f0;
  
  &:last-child {
    border-bottom: none;
  }
  
  &.total-row {
    background: #f1f5f9;
    font-weight: 600;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 10px 8px;
  text-align: center;
  font-weight: 600;
  color: #374151;
  border-right: 1px solid #e2e8f0;
  white-space: nowrap;
  
  &:last-child {
    border-right: none;
  }
`;

export const TableCell = styled.td`
  padding: 8px 6px;
  text-align: center;
  color: #1f2937;
  border-right: 1px solid #f1f5f9;
  white-space: nowrap;
  
  &:last-child {
    border-right: none;
  }
  
  strong {
    color: #dc2626;
  }
`;

/* 산소발생기 결과 컨테이너 */
export const OxygenResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/* 산소발생기 라디오 버튼 그룹 */
export const OxygenRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
  flex: 1;
`;

export const OxygenRadioItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: white;
  border: 1.5px solid #e2e8f0;
  border-radius: 6px;
  transition: all 0.2s;
  cursor: pointer;
  max-width: 160px;
  
  &:hover {
    border-color: #3b82f6;
    background: #f8fafc;
  }
  
  &:has(input:checked) {
    border-color: #3b82f6;
    background: #eff6ff;
  }
`;

export const OxygenRadioInput = styled.input`
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  
  &:checked {
    accent-color: #3b82f6;
  }
`;

export const OxygenRadioLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  flex: 1;
`;

export const OxygenFormInput = styled.input`
  flex: 1;
  max-width: 160px;
  padding: 8px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  
  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
  }
`;

export const OxygenResultItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  
  &.total-row {
    border-top: 2px solid #e5e7eb;
    padding-top: 12px;
    margin-top: 8px;
  }
`;

export const OxygenResultLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
`;

export const OxygenResultValue = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #1f2937;
  
  &.insurance-days {
    color: #059669;
  }
  
  &.non-insurance-days {
    color: #dc2626;
  }
  
  &.insurance-amount {
    color: #059669;
  }
  
  &.non-insurance-amount {
    color: #dc2626;
  }
  
  &.total-amount {
    color: #1d4ed8;
    font-size: 14px;
  }
`;

export const OxygenResultDivider = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 4px 0;
`;

/* 테이블 내 타입 배지 */
export const OxygenTypeBadge = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 8px;
  white-space: nowrap;
  
  &.insurance {
    background: linear-gradient(135deg, #059669, #047857);
    color: white;
  }
  
  &.non-insurance {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    color: white;
  }
`;

/* 애니메이션 */
export const modalIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

// 보조기기 관련 스타일 추가
export const AssistanceSelect = styled.select`
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 14px;
    background-color: white;
    min-width: 150px;
    
    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
`;

export const AssistanceRadioGroup = styled.div`
    display: flex;
    gap: 16px;
`;

export const AssistanceRadioItem = styled.label`
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 14px;
`;

export const AssistanceRadioInput = styled.input`
    margin: 0;
`;

export const AssistanceRadioLabel = styled.span`
    font-weight: 500;
    color: #495057;
`;

export const AssistanceResultContainer = styled.div`
    background: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e9ecef;
`;

export const AssistanceResultItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #e9ecef;
    
    &:last-child {
        border-bottom: none;
    }
    
    &.total-row {
        background: #e3f2fd;
        margin: 8px -16px -16px -16px;
        padding: 12px 16px;
        border-radius: 0 0 8px 8px;
        border-bottom: none;
        border-top: 2px solid #2196f3;
    }
`;

export const AssistanceResultLabel = styled.span`
    font-weight: 500;
    color: #495057;
    font-size: 14px;
`;

export const AssistanceResultValue = styled.span`
    font-weight: 600;
    color: #212529;
    font-size: 14px;
    
    &.standard-amount {
        color: #28a745;
    }
    
    &.announced-amount {
        color: #17a2b8;
    }
    
    &.purchase-amount {
        color: #fd7e14;
    }
    
    &.patient-amount {
        color: #dc3545;
    }
    
    &.claim-amount {
        color: #007bff;
        font-size: 16px;
    }
`;

export const AssistanceResultDivider = styled.div`
    height: 1px;
    background: #dee2e6;
    margin: 8px 0;
`;

// 공단 고시 내용 스타일
export const AssistanceGuideSection = styled.div`
    background: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e9ecef;
    max-height: 350px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 3px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f5f9;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 3px;
      
      &:hover {
        background: #94a3b8;
      }
    }
`;

export const AssistanceGuideContainer = styled.div`
    width: 100%;
`;

export const AssistanceGuideTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
`;

export const AssistanceGuideHeader = styled.thead`
    background: #e9ecef;
`;

export const AssistanceGuideBody = styled.tbody`
    background: white;
`;

export const AssistanceGuideRow = styled.tr`
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover {
        background-color: #f8fafc;
    }
    
    &.highlighted {
        background-color: #dbeafe;
        border-left: 4px solid #4a90e2;
    }
`;

export const AssistanceGuideCell = styled.td`
    padding: 8px 6px;
    border: 1px solid #dee2e6;
    text-align: center;
    vertical-align: top;
    
    &:first-child {
        font-weight: 600;
        color: #495057;
        min-width: 80px;
    }
    
    &:nth-child(2) {
        min-width: 200px;
    }
    
    &:last-child {
        text-align: center;
        font-weight: 600;
        color: #007bff;
        min-width: 100px;
    }
`;

export const AssistanceFormInputCompact = styled.input`
  flex: 1;
  max-width: 100px;
  padding: 8px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  
  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
  }
`;

// 보조기기 검색 관련 스타일
export const AssistanceSearchContainer = styled.div`
    position: relative;
    margin-bottom: 16px;
`;

export const AssistanceSearchInput = styled.input`
    width: 50%;
    padding: 12px 40px 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    
    &:focus {
        outline: none;
        border-color: #4a90e2;
        box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
    }
    
    &::placeholder {
        color: #9ca3af;
    }
`;

export const AssistanceNoResults = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #6b7280;
`;

export const AssistanceNoResultsIcon = styled.div`
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
`;

export const AssistanceNoResultsText = styled.div`
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
`;

export const AssistanceNoResultsSubText = styled.div`
    font-size: 14px;
    color: #9ca3af;
`;